const languagesDone = [
    
    {
        name: 'Java',
        percentDone: 75
    },
    {
        name: 'C++',
        percentDone: 60
    },
    {
        name: 'React Js',
        percentDone: 70
    },
    {
        name: 'Spring Boot',
        percentDone: 70
    },
    {
        name: 'Java Script',
        percentDone:65
    }
]
const EducationData={
    collegeName:"Sagar Institude of Science Technology and Research",
    courseName:"B.Tech in Computer Science and Engineering",
    couseStartYear:"2022",
    courseEndYear:"2026",
    details:[
        'I joined my college in 2022. Cleared First and Second Year with a good academic performance.',
        'I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, COA, AI etc.',
        ' Apart from this, I have done courses on C++, Spring Boot , and Full Stack Development.'
    ],
    codingStatus:languagesDone
}
export default EducationData;